import {
    GET_HEALTH_SCORE_FAILURE, GET_CONTRACT_MARGIN_DETAILS, GET_PARTS_OF_INDICES, GET_HEALTH_SCORE_SUCCESS,
    GET_CONTRACT_DETAILS, GET_CONTRACT_CODE_INFO, GET_CONTARCT_FAILURE, GET_COMPANY_BALANCE_SHEET_DATA_FAILURE,
    GET_COMPANY_BALANCE_SHEET_DATA_SUCCESS, GET_COMPANY_RESULT_DATA_FAILURE, GET_COMPANY_RESULT_DATA_SUCCESS,
    GET_PROFIT_LOSS_DATA_FAILURE, GET_PROFIT_LOSS_DATA_SUCCESS, GET_PUT_CALL_MASTER_DATA_FAILURE,
    GET_PUT_CALL_MASTER_DATA_SUCCESS, GET_QUARTERLY_TREND_FAILURE, GET_QUARTERLY_TREND_SUCCESS,
    GET_SHARE_HOLDING_PATTERN_DATA_FAILURE, GET_SHARE_HOLDING_PATTERN_DATA_SUCCESS, GET_KEYSTATS, GET_GSM_CATEGORY_FAILURE,
    GET_DELIVERY_QUANTITY, GET_DELIVERY_QUANTITY_FAILURE, GET_SIMPLE_MOVING_AVERAGES_FAILURE, GET_KEYSTATS_FAILURE,
    GET_GSM_CATEGORY, GET_FUTURE_DATA, GET_COMPANY_BACKGROUND_FAILURE, GET_COMPANY_BACKGROUND_DATA,
    GET_SECURITY_INFO_FAILURE, GET_COMPANY_LISTING_INFO_FAILURE, GET_BOARD_OF_DIRECTOR_FAILURE, GET_COMPANY_EXCHANGE_DATA,
    GET_RECORD_DATA, GET_LISTING_INFO, GET_MANAGEMENT_DETAILS, GET_SECURITY_DETAILS, GET_CODE_INFO, GET_COMPANY_HISTORY,
    GET_SCRIPOVERVIEW_MARKET_PULSE_SUCCESS, GET_MARKET_PULSE_FAILURE, UPDATE_MARKET_DEPTH, GET_SIMPLE_MOVING_AVERAGES,
    GET_COMPANY_INFO_FAILURE, GET_COMPANY_EXCHANGE_DATA_FAILURE, GET_FUTURE_TAB_DATA_SUCCESS,
    GET_FUTURE_TAB_DATA_FAILURE, INDICES, RESET_MARKET_OVERVIEW, SET_SCRIP_OVERVIEW_DATA,
    GET_MARKET_MOVEMENT_FAILURE, GET_MARKET_MOVEMENT_SUCCESS, GET_PEER_COMPARISON_FAILURE,
    GET_PEER_COMPARISON_SUCCESS, GET_OI_DATA_FOR_SCRIP_FAILURE_2, GET_OI_DATA_FOR_SCRIP_FAILURE_1,
    GET_OI_DATA_FOR_SCRIP_SUCCESS_2, GET_OI_DATA_FOR_SCRIP_FAILURE_3, GET_OI_DATA_FOR_SCRIP_SUCCESS_1,
    GET_OI_DATA_FOR_SCRIP_SUCCESS_3, GET_HEALTH_PARAM_SCORE_SUCCESS, GET_HEALTH_PARAM_SCORE_FAILURE,
    OVER_VIEW_CARD, GET_SCRIP_MARKET_PULSE_SUCCESS, SET_AVAILABLE_EXCHANGES, RESET_COMPANY_CONTRACT_INFO,
    SET_COMMON_COMPANY_CONTRACT_INFO, UPDATE_CONSTITUENT_VIEW, GET_HEALTH_PARAM_VALUE_SUCCESS, GET_HEALTH_PARAM_VALUE_FAILURE, GET_FINANCIAL_RATIO_DATA,
    SET_ARR_ROW_DATA,
    GET_FUTURES_COLUMNS_LIST,
    GET_CONSTITUENTS_COLUMNS_LIST,
    EXPAND_SIDE_CHART,
    SIDE_OVERVIEW_WATCHLIST_SYNC,
} from "../actionTypes";
import { convertBestFiveResponseToMarketDepthGrid, convertScripResponseConstituents, convertScripResponseWatchlistGrid, deepClone, getApiExchangeNameFromMktSegId, getAssetExchangeNameFromMktSegId } from "../../utils/global_functions";
import { getQuarterlyTrend, getShareHoldingPattern, getCompanyResult, getProfitLoss, getCompanyBalanceSheet, getConstituendsDataApi, getHealthTotalScore, getPeerComparison, getHealthParamScore, getHealthParamValues, KeyStatsFinancialRatio } from "../../apis/cds";
import { getOIDataForScrip, getPutCallMaster } from "../../apis/nontransactional";
import { _getCompanyBackground, _getFutureTabData, _getSecurityDetails, _getcompanyListingInformation, _getCompanyHistory, _getBoardOfDirectorsData, _getCompanyExchangeData, _getMarketPulse, _getContractDetails, _getMarketMovementInfo, _getGSMGradeCategory, _getSimpleMovingAverages, _getDeliveryQuantity } from "../../controllers/marketOverview";
import { API_RESPONSE_STATUS, WATCHLIST_GRID_INDEX,LOGIN_CONSTANTS } from "../../utils/global_variables";
import { _getScripsInfo } from "../../controllers";

export const updateSideExapnsion = (payload) => {
    return { type: EXPAND_SIDE_CHART, payload };
};

export const updateSideOverViewWatchlistSynced = (payload) => {
    return { type: SIDE_OVERVIEW_WATCHLIST_SYNC, payload };
};

export const getKeystats = () => {
    return { type: GET_KEYSTATS, payload: {} };
};


export const getMarketPulse = (objPayload) => async (dispatch) => {

    const objResp = await _getMarketPulse(objPayload);

    if (objResp?.status) {
        dispatch(getMarketPulseSuccess(objResp?.data?.marketPulseResp));
        //Vaibhav Singh: BT-109089: 25-10-2023: added data logic for market pulse
        dispatch(getScripInfoForMarketPulseSuccess(objResp?.data?.dataForMarketPulse));
    } else {
        dispatch(getMarketPulseFailure([]));
        dispatch(getScripInfoForMarketPulseFailure([]));
    }

};


export const updateActiveOverTab = (payload) => {
    return { type: OVER_VIEW_CARD?.UPDATE_OVERVIEW_ACTIVE_TAB, payload };
};


export const getScripInfoForMarketPulseSuccess = (payload) => {
    return { type: GET_SCRIP_MARKET_PULSE_SUCCESS, payload: payload };
};

export const getScripInfoForMarketPulseFailure = (payload) => {
    return { type: GET_SCRIP_MARKET_PULSE_SUCCESS, payload: payload };
};

export const getMarketPulseSuccess = (payload) => {
    return { type: GET_SCRIPOVERVIEW_MARKET_PULSE_SUCCESS, payload: payload };
};

export const getMarketPulseFailure = (payload) => {
    return { type: GET_MARKET_PULSE_FAILURE, payload: payload };
};

export const getCompanyFinancialSuccess = (payload) => {
    return { type: GET_KEYSTATS, payload: payload };
};

export const getCompanyFinancialFailure = (payload) => {
    return { type: GET_KEYSTATS_FAILURE, payload: payload };
};

export const getSimpleMovingAverages = (objPayload) => async (dispatch) => {

    const objResp = await _getSimpleMovingAverages(objPayload);

    if (objResp?.status) {
        dispatch(getSimpleMovingAveragesSuccess(objResp?.data));
    } else {
        dispatch(getSimpleMovingAveragesFailure([]));
    }

};

export const getSimpleMovingAveragesSuccess = (payload) => {
    return { type: GET_SIMPLE_MOVING_AVERAGES, payload: payload };
};

export const getSimpleMovingAveragesFailure = (payload) => {
    return { type: GET_SIMPLE_MOVING_AVERAGES_FAILURE, payload: payload };
};

export const getDeliveryQuantity = (objPayload) => async (dispatch) => {

    const objResp = await _getDeliveryQuantity(objPayload);

    if (objResp?.status) {
        dispatch(getDeliveryQuantitySuccess(objResp?.data));
    } else {
        dispatch(getDeliveryQuantityFailure([]));
    }

};

export const getDeliveryQuantitySuccess = (payload) => {
    return { type: GET_DELIVERY_QUANTITY, payload: payload };
};

export const getDeliveryQuantityFailure = (payload) => {
    return { type: GET_DELIVERY_QUANTITY_FAILURE, payload: payload };
};

export const updateMarketDepth = (marketDepthdata) => {
    return { type: UPDATE_MARKET_DEPTH, payload: marketDepthdata };
};
export const getMarketDepthLiveFeed = (arrBestFiveData) => async (dispatch, getState) => {
    const arrUpdatedScripDataBestFive = convertBestFiveResponseToMarketDepthGrid(arrBestFiveData);
};



export const getFutureTabDataSuccess = (payload) => {
    return { type: GET_FUTURE_TAB_DATA_SUCCESS, payload: payload };
};
export const getFutureTabDataFAilure = (payload) => {
    return { type: GET_FUTURE_TAB_DATA_FAILURE, payload: payload };
};
//AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - End


export const companyInfoManagement = (resp) => {
    return {
        type: GET_MANAGEMENT_DETAILS, payload: resp
    };
};

export const SecurityDetails = (payload) => {
    return {
        type: GET_SECURITY_DETAILS, payload: payload
    };
};

export const CodeInfo = (payload) => {
    return {
        type: GET_CODE_INFO, payload: payload
    };
};

export const GetContractDetails = (objPayload) => async (dispatch) => {

    const objRep = await _getContractDetails(objPayload);
    if (objRep?.status) {
        dispatch(ContractDetails(objRep?.data?.contractData));
        dispatch(ContractCodeInfo(objRep?.data?.data));
        dispatch(ContractMarginDetails(objRep?.data?.contractMarginData));
        return Promise.resolve(objRep?.data);
    } else {
        dispatch(getCompanyDetailsFailure([]));
    }

};

export const ContractDetails = (payload) => {
    return {
        type: GET_CONTRACT_DETAILS, payload: payload
    };
};

export const ContractCodeInfo = (payload) => {
    return {
        type: GET_CONTRACT_CODE_INFO, payload: payload
    };
};
export const ContractMarginDetails = (payload) => {
    return {
        type: GET_CONTRACT_MARGIN_DETAILS, payload: payload
    };
};

export const CompanyHistory = (payload) => {
    return {
        type: GET_COMPANY_HISTORY, payload: payload
    };
};


export const GetListingInfo = (payload) => {
    return {
        type: GET_LISTING_INFO, payload: payload
    };

};

export const GetPartsOfIndices = (payload) => {
    return {
        type: GET_PARTS_OF_INDICES, payload: payload
    };

};


export const RecordData = (payload) => {
    return {
        type: GET_RECORD_DATA, payload: payload
    };
};

export const getGSMGradeCategory = (objPayload) => async (dispatch) => {

    const objResp = await _getGSMGradeCategory(objPayload);

    if (objResp?.status) {
        dispatch(gsmGradeCategoryData(objResp?.data));
    } else {
        dispatch(getGSMCategoryFailure([]));
    }

};


export const gsmGradeCategoryData = (payload) => {
    return {
        type: GET_GSM_CATEGORY, payload: payload
    };
};

export const getHealthTotalScoreData = (objPayload) => async (dispatch) => {
    try {
        const resp = await getHealthTotalScore(objPayload);
        dispatch(getHealthTotalScoreSuccess(resp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getHealthTotalScoreFailure([]));
    }
};
export const getHealthTotalScoreFailure = (payload) => {
    return {
        type: GET_HEALTH_SCORE_FAILURE, payload: payload
    };
};

export const getHealthTotalScoreSuccess = (payload) => {
    return {
        type: GET_HEALTH_SCORE_SUCCESS, payload: payload
    };
};
export const CompanyExchange = (payload) => {
    return {
        type: GET_COMPANY_EXCHANGE_DATA, payload: payload
    };
};


export const GetCompanyBackgroundData = (payload) => {

    return {
        type: GET_COMPANY_BACKGROUND_DATA, payload: payload
    };
};



export const getIndicesSuccess = (payload) => {
    return { type: INDICES.GET_INDICES_SUCCESS, payload };
};

export const getIndicesFailure = (payload) => {
    return { type: INDICES.GET_INDICES_FAILURE, payload };
};

export const getConstituendsData = (payload, jtenantToken, indiceSegmentID) => async (dispatch) => {
    dispatch(constituentsAPIStatus(API_RESPONSE_STATUS.PENDING));
    try {
        let objResp = await getConstituendsDataApi(payload, jtenantToken);
        dispatch(constituentsAPIStatus(false));

        const data = convertScripResponseConstituents(objResp.data.ResponseObject.resultset, payload?.Exchange);
        const scripsMarketAndSegmentID = data?.map((each) => {
            if (each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
                return { mkt: getApiExchangeNameFromMktSegId(each[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: each[WATCHLIST_GRID_INDEX.TOKEN] };
            } else { }
        })
        let objScripsResp = await _getScripsInfo(scripsMarketAndSegmentID);
        const arrConvertedScripInoIntoGridData = convertScripResponseWatchlistGrid(objScripsResp?.data?.objScripsResp?.result);
        // Azeem K -05-07-2024 : Constituents Optimization --Start
        let objConstituentsIndexes = {};
        data?.forEach((each, index) => {
            const scripInfo = arrConvertedScripInoIntoGridData?.find((item) => item[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] == each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            if (scripInfo !== undefined) {
                data[index] = scripInfo;
            } else { }
            objConstituentsIndexes[each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]] = index;
        });
        dispatch(constituentsAPIStatus(API_RESPONSE_STATUS.SUCCESS));
        dispatch(getConstituentsIndexes(objConstituentsIndexes));
        // Azeem K -05-07-2024 : Constituents Optimization --End
        dispatch(constituentsDataSuccess(data));

    }
    catch (error) {
        if (error?.response?.data) {
            dispatch(constituentsAPIStatus(API_RESPONSE_STATUS.FAILURE));
            dispatch(constituentsDataFailure(error?.response?.data));
        } else {
            dispatch(constituentsDataFailure({}));
        }

    }

};

export const constituentsAPIStatus = (payload) => {
    return { type: INDICES.UPDATE_CONSTITUENT_VIEW_API_STATUS, payload };
};

export const constituentsDataSuccess = (payload) => {
    return { type: INDICES.GET_CONSTITUENTS_DATA_SUCCESS, payload };
};

export const constituentsDataFailure = (payload) => {
    return { type: INDICES.GET_CONSTITUENTS_DATA_FAILURE, payload };
};
export const getComapnyInfoFailure = (payload) => {
    return { type: GET_COMPANY_INFO_FAILURE, payload };
};


export const getBoardOfDirectorFailure = (payload) => {
    return { type: GET_BOARD_OF_DIRECTOR_FAILURE, payload };
};

export const getSecurityInfoFailure = (payload) => {
    return { type: GET_SECURITY_INFO_FAILURE, payload };
};

export const getCompanyDetailsFailure = (payload) => {
    return { type: GET_CONTARCT_FAILURE, payload };
};

export const getCompanyListingInfoFailure = (payload) => {
    return { type: GET_COMPANY_LISTING_INFO_FAILURE, payload };
};

export const getCompanyExchangeDataFailure = (payload) => {
    return { type: GET_COMPANY_EXCHANGE_DATA_FAILURE, payload };
};

export const getCompanyBackgroundFailure = (payload) => {
    return { type: GET_COMPANY_BACKGROUND_FAILURE, payload };
};

export const getGSMCategoryFailure = (payload) => {
    return { type: GET_GSM_CATEGORY_FAILURE, payload };
};
export const getFutureData = (payload) => {
    return { type: GET_FUTURE_DATA, payload };
};
export const getQuarterlyTrendData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getQuarterlyTrend(objpayload);
        dispatch(getQuarterlyTrendSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getQuarterlyTrendFailure([]));
    }
};
export const getQuarterlyTrendSuccess = (payload) => {
    return { type: GET_QUARTERLY_TREND_SUCCESS, payload };
};
export const getQuarterlyTrendFailure = (payload) => {
    return { type: GET_QUARTERLY_TREND_FAILURE, payload };
};
export const getShareHoldingPatternData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getShareHoldingPattern(objpayload);
        dispatch(getShareHoldingPatternDataSuccess(objResp));
    } catch (error) {
        dispatch(getShareHoldingPatternDataFailure([]));
    }
};
export const getShareHoldingPatternDataSuccess = (payload) => {
    return { type: GET_SHARE_HOLDING_PATTERN_DATA_SUCCESS, payload };
};
export const getShareHoldingPatternDataFailure = (payload) => {
    return { type: GET_SHARE_HOLDING_PATTERN_DATA_FAILURE, payload };
};
export const getCompanyResultData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getCompanyResult(objpayload);
        dispatch(getCompanyResultDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getCompanyResultDataFailure([]));
    }
};
export const getCompanyResultDataSuccess = (payload) => {
    return { type: GET_COMPANY_RESULT_DATA_SUCCESS, payload };
};
export const getCompanyResultDataFailure = (payload) => {
    return { type: GET_COMPANY_RESULT_DATA_FAILURE, payload };
};
export const getProfitLossData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getProfitLoss(objpayload);
        dispatch(getProfitLossDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getProfitLossDataFailure([]));
    }
};
export const getProfitLossDataSuccess = (payload) => {
    return { type: GET_PROFIT_LOSS_DATA_SUCCESS, payload };
};
export const getProfitLossDataFailure = (payload) => {
    return { type: GET_PROFIT_LOSS_DATA_FAILURE, payload };
};
export const getCompanyBalanceSheetData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getCompanyBalanceSheet(objpayload);
        dispatch(getCompanyBalanceSheetDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getCompanyBalanceSheetDataFailure([]));
    }
};
export const getCompanyBalanceSheetDataSuccess = (payload) => {
    return { type: GET_COMPANY_BALANCE_SHEET_DATA_SUCCESS, payload };
};
export const getCompanyBalanceSheetDataFailure = (payload) => {
    return { type: GET_COMPANY_BALANCE_SHEET_DATA_FAILURE, payload };
};

export const getOIDataForScripData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getOIDataForScrip(objpayload);
        if (objpayload?.expiry === "1") {
            if (objResp?.data?.status) {
                objResp?.data?.result[0]['sOIBuilUP']?.reverse();
                objResp?.data?.result[0]['sOIBuilUP30Min']?.reverse();
                objResp?.data?.result[0]['sOIBuilUP60Min']?.reverse();
                dispatch(getOIDataForScripSuccess1(objResp?.data?.result));
            }
        }
        if (objpayload?.expiry === "2") {
            if (objResp?.data?.status) {
                objResp?.data?.result[0]['sOIBuilUP']?.reverse();
                objResp?.data?.result[0]['sOIBuilUP30Min']?.reverse();
                objResp?.data?.result[0]['sOIBuilUP60Min']?.reverse();
                dispatch(getOIDataForScripSuccess2(objResp?.data?.result));
            }
        }
        if (objpayload?.expiry === "3") {
            if (objResp?.data?.status) {
                objResp?.data?.result[0]['sOIBuilUP']?.reverse();
                objResp?.data?.result[0]['sOIBuilUP30Min']?.reverse();
                objResp?.data?.result[0]['sOIBuilUP60Min']?.reverse();
                dispatch(getOIDataForScripSuccess3(objResp?.data?.result));
            }
        }
    } catch (error) {
        if (objpayload?.expiry === "1") {
            dispatch(getOIDataForScripFailure1([]));
        }
        if (objpayload?.expiry === "2") {
            dispatch(getOIDataForScripFailure2([]));
        }
        if (objpayload?.expiry === "3") {
            dispatch(getOIDataForScripFailure3([]));
        }
    }
};
export const getOIDataForScripSuccess1 = (payload) => {
    return { type: GET_OI_DATA_FOR_SCRIP_SUCCESS_1, payload };
};
export const getOIDataForScripFailure1 = (payload) => {
    return { type: GET_OI_DATA_FOR_SCRIP_FAILURE_1, payload };
};
export const getOIDataForScripSuccess2 = (payload) => {
    return { type: GET_OI_DATA_FOR_SCRIP_SUCCESS_2, payload };
};
export const getOIDataForScripFailure2 = (payload) => {
    return { type: GET_OI_DATA_FOR_SCRIP_FAILURE_2, payload };
};
export const getOIDataForScripSuccess3 = (payload) => {
    return { type: GET_OI_DATA_FOR_SCRIP_SUCCESS_3, payload };
};
export const getOIDataForScripFailure3 = (payload) => {
    return { type: GET_OI_DATA_FOR_SCRIP_FAILURE_3, payload };
};

export const getPutCallMasterData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getPutCallMaster(objpayload);
        dispatch(getPutCallMasterDataSuccess(objResp?.data?.status ? objResp?.data?.result : []));
    } catch (error) {
        dispatch(getPutCallMasterDataFailure([]));
    }
};
export const getPutCallMasterDataSuccess = (payload) => {
    return { type: GET_PUT_CALL_MASTER_DATA_SUCCESS, payload };
};
export const getPutCallMasterDataFailure = (payload) => {
    return { type: GET_PUT_CALL_MASTER_DATA_FAILURE, payload };
};

export const getPeerComparisonData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getPeerComparison(objpayload);
        dispatch(getPeerComparisonDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getPeerComparisonDataFailure([]));
    }
};
export const getPeerComparisonDataSuccess = (payload) => {
    return { type: GET_PEER_COMPARISON_SUCCESS, payload };
};
export const getPeerComparisonDataFailure = (payload) => {
    return { type: GET_PEER_COMPARISON_FAILURE, payload };
};

export const getFutureTabData = (payload) => async (dispatch, getState) => {

    const whatsHotData = deepClone(getState().dontMiss?.whatsHotData);
    let nExchangesViewAllowed = getState()?.auth?.objLoginSession?.nExchangesViewAllowed;
    let newPayload = { ...payload, nExchangesViewAllowed: nExchangesViewAllowed };
    const objResp = await _getFutureTabData(whatsHotData, newPayload);
    //Vaibhav Singh: 06-10-2023: Future Tab updated Solved future Tab issue
    let temp = objResp?.data;
    if (payload?.segment_id) {
        temp = objResp?.data?.filter(el => el.MktSegId === payload?.segment_id);
    }
    dispatch(getFutureTabDataSuccess(temp));

};



export const getCompanyBackground = (objPayload) => async (dispatch) => {

    const objResp = await _getCompanyBackground(objPayload);

    if (objResp?.status) {
        dispatch(GetCompanyBackgroundData(objResp?.data));
    } else {
        dispatch(getCompanyBackgroundFailure([]));
    }
};



export const getSecurityDetails = (objPayload) => async (dispatch) => {


    const objResp = await _getSecurityDetails(objPayload);
    // This function will display code details and security details in scripoverview => company info tab
    //objPayload contains segmentid number and token number

    if (objResp.status) {
        if (objResp?.data?.securityInfoDetails) {
            dispatch(RecordData({
                ...{
                    startDate: objResp?.data?.securityInfoDetails?.nBookClosureStartDate,
                    endDate: objResp?.data?.securityInfoDetails?.nBookClosureEndDate,
                    exDate: objResp?.data?.securityInfoDetails?.nExDate,
                    sRemarks: objResp?.data?.securityInfoDetails?.sRemarks
                }
            }));
            dispatch(SecurityDetails(objResp?.data?.securityData));
            dispatch(CodeInfo(objResp?.data?.data));
            return Promise.resolve(objResp?.data);
        }
    } else {
        dispatch(getSecurityInfoFailure([]));
    }
};


//
export const getcompanyListingInformation = (objPayload) => async (dispatch) => {

    const objResp = await _getcompanyListingInformation(objPayload);

    if (objResp?.status) {

        dispatch(GetListingInfo(objResp?.data));
    } else {

        dispatch(getCompanyListingInfoFailure([]));
    }


};



export const GetCompanyHistory = (objPayload) => async (dispatch) => {


    const objResp = await _getCompanyHistory(objPayload);
    //This function will display the company history details in scripover => company info tab
    //objPayload contains Token number and Exchange type
    if (objResp?.status) {
        dispatch(CompanyHistory(objResp?.data));
    } else {
        dispatch(getComapnyInfoFailure([]));
        //getTradeTimeForValue
    }
};

export const getCompanyExchangeData = (objPayload) => async (dispatch) => {


    const objResp = await _getCompanyExchangeData(objPayload);

    if (objResp?.status) {
        dispatch(CompanyExchange(objResp?.data));
    } else {
        dispatch(getCompanyExchangeDataFailure([]));
    }
};



export const getMarketMovementInfo = (objPayload) => async (dispatch) => {
    // Thsis function  require objMarketMovementPaylod payload && decimalLocator,decimalLocatorLength require to convert data require format
    const objResp = await _getMarketMovementInfo(objPayload);
    if (objResp?.status) {

        dispatch(getMarketMovementSuccess(objResp?.data));
    } else {
        dispatch(getMarketMovementFailure([]));

    };
};




export const GetBoardofDirectorData = (objPayload) => async (dispatch) => {


    const objResp = await _getBoardOfDirectorsData(objPayload);

    if (objResp?.status) {
        dispatch(companyInfoManagement(objResp?.data));
    } else {
        dispatch(getBoardOfDirectorFailure([]));
    }
};

export const getMarketMovementSuccess = (payload) => {
    return { type: GET_MARKET_MOVEMENT_SUCCESS, payload: payload };
};

export const getMarketMovementFailure = (payload) => {
    return { type: GET_MARKET_MOVEMENT_FAILURE, payload: payload };
};

// Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- Start
export const getCommonCompanyContractData = (availableExchanges = []) => async (dispatch) => {
    const exchange = availableExchanges[0];
    const getExchangeType = getAssetExchangeNameFromMktSegId(exchange[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
    const objPayload = {
        nToken: exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? exchange[WATCHLIST_GRID_INDEX.TOKEN] : exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
        exchangeType: getExchangeType,
        jtenanttoken:LOGIN_CONSTANTS.JTENANTTOKEN, //added by abhijeet varude for cds services other than redis :20260203
    };

    // Board of director data
    // NSE
    // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
    let companyExchangeDataResp = await _getCompanyExchangeData(objPayload);
    let boardOfDirectorResp = await _getBoardOfDirectorsData(objPayload);
    let companyHistoryResp = await _getCompanyHistory(objPayload);
    let companyListingInfoResp = await _getcompanyListingInformation(objPayload);
    let companyBackgroundResp = await _getCompanyBackground(objPayload);

    // BSE
    if (availableExchanges?.length > 1 && !companyExchangeDataResp?.status) {
        const exchange = availableExchanges[1];
        const getExchangeType = getAssetExchangeNameFromMktSegId(exchange[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        const objPayload = {
            nToken: exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? exchange[WATCHLIST_GRID_INDEX.TOKEN] : exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
            exchangeType: getExchangeType,
        };
        companyExchangeDataResp = await _getCompanyExchangeData(objPayload);
    }
    // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End

    if (availableExchanges?.length > 1 && !boardOfDirectorResp?.status) {
        const exchange = availableExchanges[1];
        const getExchangeType = getAssetExchangeNameFromMktSegId(exchange[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        const objPayload = {
            nToken: exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? exchange[WATCHLIST_GRID_INDEX.TOKEN] : exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
            exchangeType: getExchangeType,
        };
        boardOfDirectorResp = await _getBoardOfDirectorsData(objPayload);
    }

    if (availableExchanges?.length > 1 && !companyHistoryResp?.status) {
        const exchange = availableExchanges[1];
        const getExchangeType = getAssetExchangeNameFromMktSegId(exchange[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        const objPayload = {
            nToken: exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? exchange[WATCHLIST_GRID_INDEX.TOKEN] : exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
            exchangeType: getExchangeType,
        };
        companyHistoryResp = await _getCompanyHistory(objPayload);
    }

    if (availableExchanges?.length > 1 && !companyListingInfoResp?.status) {
        const exchange = availableExchanges[1];
        const getExchangeType = getAssetExchangeNameFromMktSegId(exchange[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        const objPayload = {
            nToken: exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? exchange[WATCHLIST_GRID_INDEX.TOKEN] : exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
            exchangeType: getExchangeType,
        };
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        companyListingInfoResp = await _getcompanyListingInformation(objPayload);
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End
    }

    if (availableExchanges?.length > 1 && !companyBackgroundResp?.status) {
        const exchange = availableExchanges[1];
        const getExchangeType = getAssetExchangeNameFromMktSegId(exchange[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        const objPayload = {
            nToken: exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? exchange[WATCHLIST_GRID_INDEX.TOKEN] : exchange[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
            exchangeType: getExchangeType,
        };
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        companyBackgroundResp = await _getCompanyBackground(objPayload);
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End
    }

    const payload = {
        boardOfDirectorResp: boardOfDirectorResp?.data ?? [],
        companyHistoryResp: companyHistoryResp?.data ?? '',
        companyListingInfoResp: companyListingInfoResp?.data ?? [],
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        companyBackgroundResp: companyBackgroundResp?.data ?? {},
        companyExchangeDataResp: companyExchangeDataResp?.data ?? []
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End
    };

    dispatch(setCompanyInfoInStore(payload));
};

export const setCompanyInfoInStore = (resp) => {
    return {
        type: SET_COMMON_COMPANY_CONTRACT_INFO, payload: resp
    };
};
// Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- End

export const updateSelectedArrRowData = (payload = []) => {
    return { type: SET_ARR_ROW_DATA, payload };
};

export const setScripOverviewData = (payload) => {
    return { type: SET_SCRIP_OVERVIEW_DATA, payload: payload };
};

export const resetMarketOverview = (payload) => {
    return { type: RESET_MARKET_OVERVIEW, payload: payload };
};

//BT-109089 : Vaibhav Singh : Keystats changes : redux for keystats data 
export const getHealthParamScoreData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getHealthParamScore(objpayload);
        dispatch(getHealthParamScoreDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getHealthParamScoreDataFailure(null));
    }
};
export const getHealthParamScoreDataSuccess = (payload) => {
    return { type: GET_HEALTH_PARAM_SCORE_SUCCESS, payload };
};
export const getHealthParamScoreDataFailure = (payload) => {
    return { type: GET_HEALTH_PARAM_SCORE_FAILURE, payload };
};

export const getHealthParamValueData = (objpayload) => async (dispatch) => {
    try {
        const objResp = await getHealthParamValues(objpayload);
        dispatch(getHealthParamValueDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {
        dispatch(getHealthParamValueDataFailure([]));
    }
};
export const getHealthParamValueDataSuccess = (payload) => {
    return { type: GET_HEALTH_PARAM_VALUE_SUCCESS, payload };
};
export const getHealthParamValueDataFailure = (payload) => {
    return { type: GET_HEALTH_PARAM_VALUE_FAILURE, payload };
};
export const updateActiveOverViewTab = (payload) => {
    return { type: OVER_VIEW_CARD?.UPDATE_OVERVIEW_ACTIVE_TAB, payload };
};

// Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- Start
export const setAvailableExchangesData = (payload) => {
    return { type: SET_AVAILABLE_EXCHANGES, payload };
};

export const resetCompanyContractInfo = () => {
    return { type: RESET_COMPANY_CONTRACT_INFO };
};
// Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- End
// Azeem K -05-07-2024 : Constituents Optimization --Start
export const getConstituentsIndexes = (payload) => {
    return { type: INDICES.GET_CONSTITUENTS_INDEXES, payload };
};
// Azeem K -05-07-2024 : Constituents Optimization --End
export const getFinancialRatios = (payload) => async (dispatch) => {
    try {
        const objResp = await KeyStatsFinancialRatio(payload);
        dispatch(getFinancialRatiosData(objResp?.data?.ResponseObject?.resultset));
    } catch (err) {
        dispatch(getFinancialRatiosData([]));
    }
};

export const getFinancialRatiosData = (payload) => {
    return { type: GET_FINANCIAL_RATIO_DATA, payload };
};

export const updateSelectedConstituentView = (payload) => {
    return { type: UPDATE_CONSTITUENT_VIEW, payload };
};

export const getFutureColumnsdef = (payload) => async (dispatch) => {
    try {
        const futureColumnProfile =
            [
                { headerName: 'SYMBOL', field: 'sSymbol', pinned: 'left' },
                { headerName: "LTP", field: "ltp", filter: 'agTextColumnFilter' },
                { headerName: "CHANGE", field: "changeInPrice", filter: 'agTextColumnFilter' },
                { headerName: "% CHANGE", field: "changeInPersent", filter: 'agTextColumnFilter' },
                { headerName: "BID QTY", field: "bidQty", filter: 'agNumberColumnFilter' },
                { headerName: "BID PRICE", field: "bidPrice", filter: 'agTextColumnFilter' },
                { headerName: "ASK PRICE", field: "askPrice", filter: 'agTextColumnFilter' },
                { headerName: "ASK QTY", field: "askQty", filter: 'agNumberColumnFilter' },
                { headerName: "PREMIUM/DISCOUNT", field: "premiumDiscount", filter: 'agTextColumnFilter' },
                { headerName: "HIGH", field: "high", filter: 'agTextColumnFilter' },
                { headerName: "LOW", field: "low", filter: 'agTextColumnFilter' },
            ];
        dispatch(updateFutureColdef(futureColumnProfile));
    } catch (error) {
        console.log(error);
        dispatch(updateFutureColdef([]));
    }
};


export const updateFutureColdef = (payload) => {
    return { type: GET_FUTURES_COLUMNS_LIST, payload };
};

export const getConstituentsColDef = (payload) => async (dispatch) => {

    try {
        const constituentsColumnProfile = [
            { field: WATCHLIST_GRID_INDEX.SEGMENT_ID.toString(), headerName: 'SEGMENT ID' },
            { field: WATCHLIST_GRID_INDEX.TOKEN.toString(), headerName: 'TOKEN' },
            { field: WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN.toString(), headerName: 'ID' },
            { field: WATCHLIST_GRID_INDEX.SYMBOL.toString(), headerName: 'SYMBOL' },
            { field: WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE.toString(), headerName: 'LTP', filter: 'agNumberColumnFilter', },
            { field: WATCHLIST_GRID_INDEX.LTP_PERCENT.toString(), headerName: 'CHANGE %', filter: 'agNumberColumnFilter', },
            { field: WATCHLIST_GRID_INDEX.CHANGE_IN_LTP.toString(), headerName: 'CHANGE', filter: 'agNumberColumnFilter', },
            { field: WATCHLIST_GRID_INDEX.BID_QUANTITY.toString(), headerName: 'BID QTY', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.BID_PRICE.toString(), headerName: 'BID PRICE', filter: 'agNumberColumnFilter', },
            { field: WATCHLIST_GRID_INDEX.ASK_QTY.toString(), headerName: 'ASK QTY', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.ASK_PRICE.toString(), headerName: 'ASK PRICE', filter: 'agNumberColumnFilter', },
            { field: WATCHLIST_GRID_INDEX.OPEN.toString(), headerName: 'OPEN', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.VOLUME.toString(), headerName: 'VOLUME', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.HIGH.toString(), headerName: 'HIGH', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.LOW.toString(), headerName: 'LOW', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.CLOSE.toString(), headerName: 'CLOSE', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.AVG_TRADED_PRICE.toString(), headerName: 'AVG. TRADED PRICE', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_HIGH.toString(), headerName: '52 WEEK HIGH', filter: 'agNumberColumnFilter' },
            { field: WATCHLIST_GRID_INDEX.FIFTY_TWO_WEEK_LOW.toString(), headerName: '52 WEEK LOW', filter: 'agNumberColumnFilter' },
        ];
        dispatch(updateConstituentsColdef(constituentsColumnProfile));
    } catch (error) {
        console.log(error);
        dispatch(updateConstituentsColdef([]));
    }
};

export const updateConstituentsColdef = (payload) => {
    return { type: GET_CONSTITUENTS_COLUMNS_LIST, payload };
};